import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EventEnrollmentAnalysisReason = () => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EVENT_ENROLL'
    })
  });
};
export default EventEnrollmentAnalysisReason;